import React from "react";

const KEYWORDS = new Set([
  "defun", "setq", "if", "cond", "while", "repeat", "foreach", "lambda",
  "progn", "and", "or", "not", "quote", "function", "vl-load-com",
]);

function tokenizeLine(line, keyBase) {
  // Comments first
  const cmtIdx = line.indexOf(";");
  let code = line, comment = null;
  if (cmtIdx !== -1) {
    // naive: treat ; as comment start (LISP comment)
    code = line.slice(0, cmtIdx);
    comment = line.slice(cmtIdx);
  }
  const parts = [];
  const regex = /("(?:[^"\\]|\\.)*"?)|(\()|(\))|([^\s()"]+)|(\s+)/g;
  let m;
  let expectFn = false;
  let i = 0;
  while ((m = regex.exec(code)) !== null) {
    const [full, str, open, close, word, ws] = m;
    const key = `${keyBase}-${i++}`;
    if (str !== undefined) parts.push(<span key={key} className="tok-str">{full}</span>);
    else if (open !== undefined) { parts.push(<span key={key} className="tok-paren">(</span>); expectFn = true; continue; }
    else if (close !== undefined) parts.push(<span key={key} className="tok-paren">)</span>);
    else if (ws !== undefined) parts.push(<span key={key}>{full}</span>);
    else if (word !== undefined) {
      const lw = word.toLowerCase();
      let cls = "";
      if (/^-?\d+\.?\d*$/.test(word)) cls = "tok-num";
      else if (KEYWORDS.has(lw)) cls = "tok-kw";
      else if (expectFn) cls = "tok-fn";
      parts.push(<span key={key} className={cls}>{word}</span>);
      expectFn = false;
    }
  }
  if (comment !== null) parts.push(<span key={`${keyBase}-c`} className="tok-cmt">{comment}</span>);
  return parts;
}

export const LispCode = ({ code }) => {
  const lines = (code || "").split("\n");
  return (
    <pre className="lisp-code font-mono text-[13px] leading-relaxed p-4 m-0 whitespace-pre-wrap break-words" data-testid="lisp-code-block">
      {lines.map((ln, idx) => (
        <div key={idx} className="flex">
          <span className="select-none text-[#3a3a46] w-8 shrink-0 text-right pr-3">{idx + 1}</span>
          <span className="flex-1">{tokenizeLine(ln, idx) }{ln === "" ? " " : null}</span>
        </div>
      ))}
    </pre>
  );
};
